var styles = {"overlay":"styles_overlay__2tQmZ flex flex-column justify-center items-center","modal":"styles_modal__vKCeG","modalContent":"styles_modalContent__EPVMn"};

export default styles;
//# sourceMappingURL=styles.css.js.map
